import { render, staticRenderFns } from "./tool-adder.vue?vue&type=template&id=6b82394a&"
import script from "./tool-adder.vue?vue&type=script&lang=ts&"
export * from "./tool-adder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports